import { Box } from "grommet";
import React, { useEffect, useState } from "react";
import { Bar, Line } from 'react-chartjs-2';
import { useStore } from "../../../../../../../Hooks/useStore";
import {
  Chart as ChartJS,
  LineElement,
  PointElement,
  LinearScale,
  Title,
  Tooltip,
  Legend,
} from 'chart.js';
ChartJS.register(LineElement, PointElement, LinearScale, Title, Tooltip, Legend);

type Series = {
  ems: number[],
  pilot: number[],
  crew: number[],
  dates?: string[],
  labels?: string[],
};

interface Dataset {
  label: string;
  data: number[];
  backgroundColor?: string;
  borderColor?: string;
  borderWidth?: number;
}

interface ChartData {
  labels: (string | number)[];
  datasets: Dataset[];
}

function VideocallLineChart({
  data,
  usertype
}: {
  data: Series;
  usertype: string;
}) {
  const { rootStore } = useStore();
  const [chartData2, setChartData2] = useState<ChartData>({
    labels: [],
    datasets: []
  });

  // alert(JSON.stringify(data))

  useEffect(() => {
    let labels: (string | number)[] = [];
    switch (rootStore.adminHomeStore.getVGraphActiveButton) {
      case 0:
        labels = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
        break;
      case 1:
        if (data.labels) {
          labels = data.labels;
        }
        break;
      case 2:
        labels = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
        break;
      default:
        console.log("Invalid state");
        break;
    }

    const datasets: Dataset[] = [
      {
        label: 'Crew',
        data: data.crew,
        borderColor: '#F89741',
        backgroundColor: '#F89741',
      },
      {
        label: 'Pilot',
        data: data.pilot,
        borderColor: '#357EFF',
        backgroundColor: '#357EFF',
      },
    ];
    if (usertype !== "admin") {
      datasets.push({
        label: 'EMS',
        data: data.ems,
        borderColor: '#27DFA5',
        backgroundColor: '#27DFA5',
      });
    }

    setChartData2({
      labels: labels,
      datasets: datasets
    });
  }, [data]);

  return (
    <div style={{ width: '100%', height: '300px' }}>
      <Line
        data={chartData2}
        options={{
          responsive: true,
          maintainAspectRatio: false,
          plugins: {
            title: {
              display: true,
              color: "#333",
            },
            legend: {
              display: true,
              position: 'bottom',
              align: 'center',
              labels: {
                usePointStyle: true,
                boxWidth: 10,
                boxHeight: 10,
                padding: 8,
                font: {
                  weight: 400,
                  size: 10,
                  family: "Inter"
                },
                borderRadius: 100,
                pointStyle: false,
              },
            },
          },
          layout: {
            autoPadding: true,
            padding: 0
          },
          scales: {
            x: {
              beginAtZero: true,
            },
            y: {
              beginAtZero: true,
            },
          },
        }}
      />
    </div>
  );
}

export default VideocallLineChart;
